import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { getCategories } from "../api";
import type { CategoryType } from "../types";
export function useCategories(type) {
  const $ = _c(2);
  let t0;
  if ($[0] !== type) {
    t0 = {
      queryKey: ["categories", type],
      queryFn: () => getCategories(type),
      staleTime: 300000
    };
    $[0] = type;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
}